import { Component, HostBinding } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { LayoutBase } from '../../base/layout.base';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'smm-mobile-menu',
  imports: [TranslateModule, RouterLink],
  templateUrl: './mobile-menu.html',
  styleUrl: './mobile-menu.scss',
})
export class MobileMenu extends LayoutBase {
  @HostBinding('class.is-active') get active() {
    return this.menuService.isOpen();
  }

  navigate(id: string) {
    this.handleNavClick(id);
    this.closeMenu();
  }
  closeMenu() {
    this.menuService.close();
  }
}
